import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  private currentVersion = environment.appVersion;
  private versionEndpoint = environment.baseUrl + '/assets/version.json';

  constructor(private http: HttpClient, private api: ApiService) {}

  public initVersionCheck(): void {
    setInterval(() => {
      this.http.get<{ version: string }>(this.versionEndpoint)
        .subscribe(versionInfo => {
          const newVersion = versionInfo.version;
          if (this.currentVersion && this.currentVersion !== newVersion) {
            this.promptUserToReload();
          }
          this.currentVersion = newVersion;
      });
    }, 600000); // Check every 10 minute
  }

  private promptUserToReload(): void {
    if (confirm('Új verzió elérhető. Kérlek töltsd újra az oldalt!')) {
      window.location.reload();
    }
  }
}
